export interface SavedVoiceRecording { id: string; name: string; locale: string; cloned: boolean }

/** Save a private reference recording; no Fish clone or TTS is purchased here. */
export async function saveVoiceRecording(file: File, name: string, language: string, consentAccepted: boolean): Promise<SavedVoiceRecording> {
  if (!consentAccepted) throw new Error("Confirm permission to use this voice first.");
  if (!file.size || file.size > 20 * 1024 * 1024) throw new Error("Choose an audio recording up to 20MB.");
  const endpoint = "/api/voices/clones";
  let response = await fetch(endpoint, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ filename: file.name, mime: file.type, size: file.size, name: name.trim() || "My voice", language, consentAccepted: true }) });
  if (response.status === 400) {
    const form = new FormData(); form.set("file", file); form.set("name", name.trim() || "My voice"); form.set("language", language); form.set("consentAccepted", "true");
    response = await fetch(endpoint, { method: "POST", body: form });
  } else if (response.ok) {
    const prepared = await response.json() as { uploadUrl: string; item: { id: string; mime: string } };
    const put = await fetch(prepared.uploadUrl, { method: "PUT", headers: { "content-type": prepared.item.mime }, body: file });
    if (!put.ok) throw new Error("Voice upload failed. Please try again.");
    response = await fetch(endpoint, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ action: "complete", id: prepared.item.id }) });
  }
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || "Could not save this voice recording.");
  if (!payload.id || !payload.name) throw new Error("Voice recording returned an invalid response.");
  return payload as SavedVoiceRecording;
}
